import React, { useEffect, useMemo } from 'react'
import useCurrentUser from 'auth/useCurrentUser'

export const AmplitudeContext = React.createContext()

export const AmplitudeProvider = ({ analytics, experiment, children }) => {
  const [{ currentUser }] = useCurrentUser()
  useEffect(() => {
    if (currentUser) {
      analytics.getInstance().setUserId(currentUser.id)
      analytics.getInstance().setUserProperties(currentUser)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser])

  const value = useMemo(() => ({ analytics, experiment }), [
    analytics,
    experiment,
  ])

  return (
    <AmplitudeContext.Provider value={value}>
      {children}
    </AmplitudeContext.Provider>
  )
}

export const AmplitudeConsumer = AmplitudeContext.Consumer
